export const MAP_ENTITY_DRAWER_WIDTH = 532;

export const MAP_ENTITY_DRAWER_MIN_SNAP_PCT = 0.207;

export const CAMERA_DRAWER_MIN_SNAP_PCT = 0.1;
